import React, { useRef } from "react";
import html2canvas from "html2canvas";
import certificateImage from "../../college/assets/new-participation-certificate.png";
import signatureImage from "../../college/assets/RajashekarSignature.png";
import moment from "moment";
import "./NewParticipationCertificate.scss";

interface NewParticipationCertificateProps {
  defaultName?: string;
  defaultCertificateId?: string;
  defaultDate?: string;
  certificateImageSrc?: string;
}

const NewParticipationCertificate: React.FC<
  NewParticipationCertificateProps
> = ({
  defaultName = "Venkata",
  defaultCertificateId = "CMPT-1000932025",
  defaultDate = moment().format("DD/MM/YYYY"),
  certificateImageSrc = certificateImage,
}) => {
  const certificateRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="new-participation-certificate-wrapper" ref={certificateRef}>
      <img
        src={certificateImageSrc}
        alt="Certificate of Participation"
        className="new-participation-certificate-image"
      />
      <div className="new-participation-certificate-text">
        {/* Name */}
        <div className="new-participation-certificate-name">{defaultName}</div>
        
        {/* Signature */}
        <div className="participation-signature-container">
          {signatureImage && (
            <img
              src={signatureImage}
              alt="Signature"
              className="new-participation-certificate-signature"
            />
          )}
        </div>

        {/* Certificate ID */}
        <div className="participation-certificate-details-left">
          <div className="participation-details-group">
            <span className="new-participation-certificate-id">
              {defaultCertificateId}
            </span>
          </div>
        </div>

        {/* Date */}
        <div className="participation-certificate-details-right">
          <div className="participation-details-group">
            <span className="new-participation-certificate-date">
              {defaultDate}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewParticipationCertificate;
